/* ==========================================================================
   CL - Carrusel Oscuro - comportamiento
   - Un carrusel por panel (cada pestana = un panel)
   - Flechas por pagina + scroll tactil (sin bucle, la flecha del borde
     se esconde al llegar al principio o al final)
   - Bucle sin corte (data-cl-loop="true"): se clonan las ultimas cards al
     inicio y las primeras al final; cuando el scroll se detiene dentro de
     una zona clonada, la pista salta en seco a la posicion equivalente de
     las cards reales. Como las clonadas son identicas y quedan en el mismo
     lugar, el salto no se nota. No es infinito: solo parece.
   - Pestanas: cambian de panel; la picada se va a primera posicion
   - Boton del banner abajo: con banner prendido aparece cuando el banner
     ya salio de la vista (sin banner se ve siempre)
   - Overlays de degradado que se prenden solo con contenido cortado
   - Tooltip de cashback: hover en desktop, tap en mobile
   - Carrito "bag": agrega via /cart/add.js y abre/refresca el
     cart-drawer nativo del tema
   ========================================================================== */

(function () {
	'use strict';

	/* Prende/apaga los degradados de un scroller sobre su contenedor.
	   isLoop(): en bucle siempre hay contenido de los dos lados. */
	function setupFades(scroller, host, isLoop) {
		function update() {
			var canScroll = scroller.scrollWidth > scroller.clientWidth + 8;
			var loop = isLoop ? isLoop() : false;
			var atStart = scroller.scrollLeft <= 8;
			var atEnd =
				scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 8;
			host.classList.toggle('clc--fade-left', canScroll && (loop || !atStart));
			host.classList.toggle('clc--fade-right', canScroll && (loop || !atEnd));
		}
		scroller.addEventListener('scroll', update, { passive: true });
		update();
		return update;
	}

	/* Salto sin animacion aunque el track tenga scroll-behavior: smooth */
	function jumpTo(track, x) {
		try {
			track.scrollTo({ left: x, behavior: 'instant' });
		} catch (e) {
			var prev = track.style.scrollBehavior;
			track.style.scrollBehavior = 'auto';
			track.scrollLeft = x;
			track.style.scrollBehavior = prev;
		}
	}

	/* ---------- Bucle sin corte ---------- */
	function createLoop(track, cardSel, enabled) {
		var state = { on: false, k: 0, total: 0, step: 0 };

		function realCards() {
			return Array.prototype.filter.call(track.querySelectorAll(cardSel), function (c) {
				return !c.classList.contains('is-clone');
			});
		}

		function clearClones() {
			track.querySelectorAll(cardSel + '.is-clone').forEach(function (c) {
				c.parentNode.removeChild(c);
			});
		}

		function makeClone(card) {
			var c = card.cloneNode(true);
			c.classList.add('is-clone');
			c.setAttribute('aria-hidden', 'true');
			c.removeAttribute('data-shopify-editor-block');
			c.querySelectorAll('a, button, [tabindex]').forEach(function (el) {
				el.setAttribute('tabindex', '-1');
			});
			return c;
		}

		/* Indice (fraccionario) de la card real que esta al inicio de la vista */
		function realIndex() {
			if (!state.step) return 0;
			if (!state.on) return track.scrollLeft / state.step;
			var i = track.scrollLeft / state.step - state.k;
			return ((i % state.total) + state.total) % state.total;
		}

		/* Crea o rehace las clonadas segun cuantas cards caben; conserva la
		   card real que se estaba viendo. */
		function build(m) {
			var cards = realCards();
			var total = cards.length;
			var need = enabled && total > m.perView && m.cardStep > 0;
			var k = need ? Math.min(total, m.perView + 2) : 0;
			var cur = realIndex();
			if (k === state.k && total === state.total && state.on === need) {
				state.step = m.cardStep;
				return;
			}
			clearClones();
			if (need) {
				var head = document.createDocumentFragment();
				var tail = document.createDocumentFragment();
				cards.slice(-k).forEach(function (c) { head.appendChild(makeClone(c)); });
				cards.slice(0, k).forEach(function (c) { tail.appendChild(makeClone(c)); });
				track.insertBefore(head, track.firstChild);
				track.appendChild(tail);
			}
			state.on = need;
			state.k = k;
			state.total = total;
			state.step = m.cardStep;
			jumpTo(track, (k + Math.max(0, Math.round(cur))) * m.cardStep);
		}

		/* Llamar cuando el scroll se detiene: si quedo en zona clonada,
		   brinca a la posicion equivalente entre las cards reales. */
		function settle() {
			if (!state.on || !state.step) return false;
			var x = track.scrollLeft;
			var span = state.total * state.step;
			var minX = (state.k - 0.5) * state.step;
			var maxX = (state.k + state.total - 0.5) * state.step;
			if (x >= maxX) {
				jumpTo(track, x - span);
				return true;
			}
			if (x < minX) {
				jumpTo(track, x + span);
				return true;
			}
			return false;
		}

		return { state: state, build: build, settle: settle, realIndex: realIndex, realCards: realCards };
	}

	function initCarousel(panel, loopEnabled) {
		var viewport = panel.querySelector('.clc__viewport');
		var track = panel.querySelector('.clc__track');
		var prev = panel.querySelector('.clc__arrow--prev');
		var next = panel.querySelector('.clc__arrow--next');
		if (!track || !viewport) return null;

		var loop = createLoop(track, '.clc-card', loopEnabled);

		function metrics() {
			var card = track.querySelector('.clc-card');
			if (!card) return null;
			var styles = window.getComputedStyle(track);
			var gap = parseFloat(styles.columnGap || styles.gap) || 0;
			var cardStep = card.offsetWidth + gap;
			var perView = Math.max(1, Math.floor(track.clientWidth / cardStep));
			var total = loop.realCards().length;
			var pages = Math.max(1, Math.ceil(total / perView));
			return { cardStep: cardStep, perView: perView, total: total, pages: pages };
		}

		function pageWidth(m) {
			return m.cardStep * m.perView;
		}

		/* Centra las flechas sobre el header de la card */
		function positionArrows() {
			var header = track.querySelector('.clc-card__header');
			if (!header) return;
			panel.style.setProperty(
				'--clc-arrow-top',
				(8 + header.offsetHeight / 2) + 'px'
			);
		}

		function updateArrows() {
			if (!prev || !next) return;
			if (loop.state.on) {
				prev.disabled = false;
				next.disabled = false;
				return;
			}
			/* Sin bucle: la flecha del borde se esconde (CSS [disabled]).
			   El track tiene padding lateral y el snap deja la primera card
			   a esa distancia (no en 0): la tolerancia incluye el padding. */
			var cs = window.getComputedStyle(track);
			var padL = parseFloat(cs.paddingLeft) || 0;
			var padR = parseFloat(cs.paddingRight) || 0;
			var maxScroll = track.scrollWidth - track.clientWidth - padR - 6;
			prev.disabled = track.scrollLeft <= padL + 6;
			next.disabled = track.scrollLeft >= maxScroll;
		}

		/* Marca la(s) card(s) visibles con .clc-card--inview (>=60% dentro
		   del carrusel). El CSS solo usa esta clase en mobile (hover:none)
		   para prender el rebote de la moneda de la card que se esta viendo. */
		function updateInView() {
			var trackRect = track.getBoundingClientRect();
			track.querySelectorAll('.clc-card').forEach(function (card) {
				var r = card.getBoundingClientRect();
				if (r.width <= 0) {
					card.classList.remove('clc-card--inview');
					return;
				}
				var visible =
					Math.min(r.right, trackRect.right) - Math.max(r.left, trackRect.left);
				var ratio = Math.max(0, visible) / r.width;
				card.classList.toggle('clc-card--inview', ratio >= 0.6);
			});
		}

		var updateFades = setupFades(track, viewport, function () { return loop.state.on; });

		/* Boton del banner abajo (.clc__footer--auto): solo se ve cuando el
		   banner (o alguna de sus clonadas del bucle) ya salio de la vista.
		   "Verse" = mas de la mitad del banner dentro de la pista; el asomo
		   de la siguiente card (peek) no cuenta. Sin la clase --auto (banner
		   apagado) el boton se ve siempre. */
		var footer = panel.querySelector('[data-cl-footer].clc__footer--auto');
		var footerRaf = 0;
		function updateFooter() {
			if (!footer) return;
			var tr = track.getBoundingClientRect();
			var banners = track.querySelectorAll('[data-cl-banner]');
			var seen = false;
			for (var i = 0; i < banners.length; i++) {
				var r = banners[i].getBoundingClientRect();
				var vis = Math.min(r.right, tr.right) - Math.max(r.left, tr.left);
				if (r.width > 0 && vis / r.width >= 0.5) {
					seen = true;
					break;
				}
			}
			footer.classList.toggle('is-visible', !seen);
		}
		if (footer) {
			track.addEventListener('scroll', function () {
				if (footerRaf) return;
				footerRaf = window.requestAnimationFrame(function () {
					footerRaf = 0;
					updateFooter();
				});
			}, { passive: true });
		}

		/* Navegacion por pagina con destino absoluto: si se pica varias
		   veces seguidas, cada clic suma una pagina al destino pendiente en
		   vez de medir desde donde va la animacion. Si el destino cae fuera
		   de la zona clonada, primero se brinca (sin que se note) al tramo
		   equivalente y luego se anima. */
		var pending = null;
		function go(dir) {
			var m = metrics();
			if (!m) return;
			var base = pending !== null ? pending : Math.round(track.scrollLeft / m.cardStep);
			var target = base + dir * m.perView;
			if (loop.state.on) {
				/* Solo se brinca si la posicion equivalente existe; si no,
				   el destino se queda en la zona clonada y settle() brinca
				   al terminar la animacion. */
				var tot = loop.state.total;
				var span = tot * m.cardStep;
				var maxX = track.scrollWidth - track.clientWidth;
				if (target >= loop.state.k + tot && track.scrollLeft - span >= 0) {
					jumpTo(track, track.scrollLeft - span);
					target -= tot;
				} else if (target < 0 && track.scrollLeft + span <= maxX) {
					jumpTo(track, track.scrollLeft + span);
					target += tot;
				}
			}
			var maxIdx = Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / m.cardStep));
			target = Math.max(0, Math.min(maxIdx, target));
			pending = target;
			pendingSince = Date.now();
			track.scrollTo({ left: target * m.cardStep, behavior: 'smooth' });
		}
		if (prev) prev.addEventListener('click', function () { go(-1); });
		if (next) next.addEventListener('click', function () { go(1); });

		/* Al detenerse el scroll: brinco del bucle (si toca) y refresco de UI */
		var touching = false;
		track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
		track.addEventListener('touchend', function () {
			touching = false;
			scheduleSettle();
		}, { passive: true });
		track.addEventListener('touchcancel', function () { touching = false; }, { passive: true });

		var scrollTimer;
		var pendingSince = 0;
		function onSettle() {
			if (touching) return;
			/* Si hay un destino de flecha pendiente y todavia no llegamos
			   (p. ej. el brinco previo disparo scrollend antes de que
			   arrancara la animacion), esperar; no brincar a medio camino. */
			if (pending !== null) {
				var m = metrics();
				var dist = m ? Math.abs(track.scrollLeft - pending * m.cardStep) : 0;
				if (m && dist > m.cardStep * 0.5 && Date.now() - pendingSince < 1500) {
					scheduleSettle();
					return;
				}
				pending = null;
			}
			loop.settle();
			updateArrows();
			updateInView();
			updateFooter();
		}
		function scheduleSettle() {
			window.clearTimeout(scrollTimer);
			scrollTimer = window.setTimeout(onSettle, 90);
		}
		track.addEventListener('scroll', scheduleSettle, { passive: true });
		if ('onscrollend' in window) {
			track.addEventListener('scrollend', function () {
				window.clearTimeout(scrollTimer);
				onSettle();
			});
		}

		function refresh() {
			var m = metrics();
			if (m && track.clientWidth > 0) loop.build(m);
			positionArrows();
			updateArrows();
			updateFades();
			updateInView();
			updateFooter();
		}

		refresh();
		return { refresh: refresh };
	}

	/* ---------- Tooltip de cashback (tap en mobile) ----------
	   Delegado en la raiz para que tambien funcione en las cards clonadas. */
	function initCash(root) {
		root.addEventListener('click', function (e) {
			var coin = e.target.closest('.clc-card__coin');
			if (!coin || !root.contains(coin)) return;
			var cash = coin.closest('[data-cl-cash]');
			if (!cash) return;
			/* solo togglear por tap donde no hay hover real */
			if (window.matchMedia('(hover: none)').matches) {
				e.preventDefault();
				e.stopPropagation();
				var isOpen = cash.classList.toggle('clc-card__cash--open');
				if (isOpen) {
					root.querySelectorAll('.clc-card__cash--open').forEach(function (c) {
						if (c !== cash) c.classList.remove('clc-card__cash--open');
					});
				}
			}
		});
		/* cerrar al tocar fuera */
		document.addEventListener('click', function (e) {
			if (e.target.closest('[data-cl-cash]')) return;
			root.querySelectorAll('.clc-card__cash--open').forEach(function (c) {
				c.classList.remove('clc-card__cash--open');
			});
		});
	}

	/* ---------- Carrito "bag": add + abre/refresca el drawer del tema ---------- */
	function initCart(root) {
		root.addEventListener('click', function (e) {
			var btn = e.target.closest('[data-cl-add]');
			if (!btn) return;
			e.preventDefault();
			if (btn.disabled || btn.classList.contains('is-loading')) return;

			var id = btn.getAttribute('data-variant-id');
			if (!id) return;

			btn.classList.add('is-loading');

			var drawer = document.querySelector('cart-drawer');
			var body = { id: id, quantity: 1 };
			/* pedir las secciones que el drawer del tema sabe pintar */
			if (drawer && typeof drawer.renderContents === 'function') {
				body.sections = 'cart-drawer,cart-icon-bubble';
				body.sections_url = window.location.pathname;
			}

			fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/javascript'
				},
				body: JSON.stringify(body)
			})
				.then(function (r) {
					return r.json();
				})
				.then(function (data) {
					if (data && data.status) {
						/* error de Shopify (p. ej. sin stock) */
						return;
					}
					if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
						drawer.renderContents(data);
					} else {
						/* fallback: dispara refresco del carrito del tema */
						document.dispatchEvent(
							new CustomEvent('cart:refresh', { bubbles: true })
						);
						var bubble = document.querySelector('#cart-icon-bubble');
						if (bubble) bubble.click();
					}
				})
				.catch(function () {})
				.finally(function () {
					btn.classList.remove('is-loading');
				});
		});
	}

	function initCarruselOscuro(root) {
		if (!root || root.dataset.clInit === 'true') return;
		root.dataset.clInit = 'true';

		var loopEnabled = root.getAttribute('data-cl-loop') !== 'false';
		var panels = Array.prototype.slice.call(
			root.querySelectorAll('[data-cl-panel]')
		);
		var carousels = panels.map(function (p) {
			return initCarousel(p, loopEnabled);
		});

		/* ---------- Pestanas ---------- */
		var tabsWrap = root.querySelector('.clc__tabs-wrap');
		var tabsScroller = root.querySelector('.clc__tabs');
		var tabs = root.querySelectorAll('.clc__tab');
		var updateTabFades = null;

		if (tabsScroller && tabsWrap) {
			updateTabFades = setupFades(tabsScroller, tabsWrap);

			tabs.forEach(function (tab, i) {
				tab.addEventListener('click', function () {
					tabs.forEach(function (t, j) {
						t.classList.toggle('clc__tab--active', i === j);
						t.setAttribute('aria-selected', i === j ? 'true' : 'false');
					});
					panels.forEach(function (p, j) {
						if (i === j) {
							p.removeAttribute('hidden');
						} else {
							p.setAttribute('hidden', '');
						}
					});
					/* titulo + descripcion propios de la pestana */
					root.querySelectorAll('[data-cl-intro]').forEach(function (intro, j) {
						if (i === j) {
							intro.removeAttribute('hidden');
						} else {
							intro.setAttribute('hidden', '');
						}
					});
					/* los paneles ocultos no tienen medidas: recalcular al mostrar */
					if (carousels[i]) carousels[i].refresh();
					/* la pestana picada se desliza a primera posicion */
					tabsScroller.scrollTo({
						left: Math.max(0, tab.offsetLeft - 2),
						behavior: 'smooth'
					});
				});
			});
		}

		initCash(root);
		initCart(root);

		var resizeTimer;
		window.addEventListener(
			'resize',
			function () {
				window.clearTimeout(resizeTimer);
				resizeTimer = window.setTimeout(function () {
					panels.forEach(function (p, i) {
						if (!p.hasAttribute('hidden') && carousels[i]) carousels[i].refresh();
					});
					if (updateTabFades) updateTabFades();
				}, 150);
			},
			{ passive: true }
		);
	}

	function initAll() {
		document.querySelectorAll('.clc').forEach(initCarruselOscuro);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
